import { AbilityBuilder, createMongoAbility } from '@casl/ability'

export const ability = createMongoAbility()

export function buildPermissionRules(permissions) {
    const { can, rules } = new AbilityBuilder(createMongoAbility)
    if (permissions != null) {
        permissions.forEach(elem => can('do', elem))
    }
    return rules
}

export const abilityPlugin = (store) => {

    ability.update(buildPermissionRules(store.state.account.permissions))

    return store.subscribe((mutation) => {

        switch (mutation.type) {
            case 'account/refreshPermissions':
                ability.update(buildPermissionRules(mutation.payload))
                store.commit('account/abilityRefreshed')
                break
            case 'account/logout':
                ability.update([])
                store.commit('account/abilityRefreshed')
                break
        }
    })
}
